import * as types from './types';

export const refreshReplacements = () => ({
  type: types.CHANGE_REPLACEMENTS_VERSION
});
